import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrl: './coming-soon.component.scss',
  imports: [
    TranslatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComingSoonComponent {

}
